export default "__VITE_ASSET__BEKiKmch__"